import { render } from "./progress-bar.vue?vue&type=template&id=f981a99e&scoped=true"
const script = {}

import "./progress-bar.vue?vue&type=style&index=0&id=f981a99e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f981a99e"]])